import { AdvancedMarker } from '@vis.gl/react-google-maps';
import { useMemo } from 'react';
import { StorefrontGroup } from './StorefrontMap';

type Props = {
  groups: StorefrontGroup[];
  onStorefrontClick: (group: StorefrontGroup) => void;
};

function getHeatColor(count: number, maxCount: number): string {
  // Normalize count relative to the max in this dataset
  const ratio = Math.min(count / Math.max(maxCount, 1), 1);

  // Color scale: blue (low) → green → yellow → orange → red (high)
  if (ratio < 0.15) return '#3498db'; // blue
  if (ratio < 0.3) return '#2ecc71';  // green
  if (ratio < 0.5) return '#f1c40f';  // yellow
  if (ratio < 0.75) return '#e67e22'; // orange
  return '#e74c3c';                    // red
}

const StorefrontMarkers = ({ groups, onStorefrontClick }: Props) => {
  const maxCount = useMemo(
    () => Math.max(...groups.map((g) => g.users.length), 1),
    [groups],
  );

  return (
    <>
      {groups.map((group) => {
        const size = Math.max(40, Math.min(64, 40 + Math.log2(group.users.length) * 8));
        const color = getHeatColor(group.users.length, maxCount);

        return (
          <AdvancedMarker
            key={group.storeFront}
            position={group.center}
            onClick={() => onStorefrontClick(group)}
          >
            <div
              style={{
                width: size,
                height: size,
                borderRadius: '50%',
                backgroundColor: color,
                border: '3px solid white',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.3)',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                transition: 'transform 0.2s ease',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'scale(1.15)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'scale(1)';
              }}
            >
              <span
                style={{
                  color: 'white',
                  fontSize: size > 50 ? 14 : 12,
                  fontWeight: 700,
                  lineHeight: 1,
                  textShadow: '0 1px 2px rgba(0,0,0,0.5)',
                }}
              >
                {group.users.length}
              </span>
              <span
                style={{
                  color: 'white',
                  fontSize: size > 50 ? 10 : 8,
                  fontWeight: 600,
                  lineHeight: 1,
                  marginTop: 2,
                  textShadow: '0 1px 2px rgba(0,0,0,0.5)',
                }}
              >
                {group.storeFront}
              </span>
            </div>
          </AdvancedMarker>
        );
      })}
    </>
  );
};

export default StorefrontMarkers;
